var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7114 26.2904L24.0014 22.6104C25.4415 20.8148 26.1389 18.5357 25.9502 16.2417C25.7615 13.9477 24.701 11.8132 22.9869 10.277C21.2727 8.7409 19.0352 7.9199 16.7343 7.98286C14.4334 8.04582 12.2441 8.98795 10.6165 10.6155C8.98893 12.2431 8.0468 14.4324 7.98384 16.7333C7.92088 19.0342 8.74188 21.2718 10.278 22.9859C11.8142 24.7001 13.9487 25.7605 16.2427 25.9492C18.5367 26.1379 20.8158 25.4405 22.6114 24.0004L26.2914 27.6804C26.3843 27.7741 26.4949 27.8485 26.6168 27.8993C26.7387 27.9501 26.8694 27.9762 27.0014 27.9762C27.1334 27.9762 27.2641 27.9501 27.3859 27.8993C27.5078 27.8485 27.6184 27.7741 27.7114 27.6804C27.8916 27.4939 27.9924 27.2447 27.9924 26.9854C27.9924 26.7261 27.8916 26.4769 27.7114 26.2904ZM17.0014 24.0004C15.6169 24.0004 14.2635 23.5899 13.1124 22.8207C11.9612 22.0515 11.064 20.9583 10.5342 19.6792C10.0044 18.4001 9.86578 16.9926 10.1359 15.6348C10.406 14.2769 11.0727 13.0296 12.0516 12.0506C13.0306 11.0717 14.2779 10.405 15.6357 10.1349C16.9936 9.8648 18.4011 10.0034 19.6802 10.5332C20.9592 11.063 22.0525 11.9603 22.8217 13.1114C23.5908 14.2625 24.0014 15.6159 24.0014 17.0004C24.0014 18.8569 23.2639 20.6374 21.9511 21.9501C20.6384 23.2629 18.8579 24.0004 17.0014 24.0004Z",
    fill: "#65697D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#65697D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSearchIcon);
export default __webpack_public_path__ + "static/media/header-search-icon.1b0844126b5f51f22d3b9c748255c9f1.svg";
export { ForwardRef as ReactComponent };